// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__fr7oP","bigColWidth":"Table_bigColWidth__3CN8O","biggerColWidth":"Table_biggerColWidth__1DJat","row":"Table_row__2BCmY","col":"Table_col__2_cjC"};